import NavBar from "../../components/NavBar/NavBar";
import Footer from '../../components/Footer/Footer'
import Title from '../../components/Title/Title'
import List from "../../components/Horizontal-list/list";
import CircleCard from "../../components/Circle-Card/Circle-Card";
import CustomButton from "../../components/Custom-Button/CustomButton";
export default function Lady() {
    return (
        <div>
            <NavBar/>
            <Title text={'Nossa Senhora'}/>            

            <CircleCard imagem={"https://nsykpvjwslvdnfbknhmm.supabase.co/storage/v1/object/public/church/Paintings/Mary.jpg"} alt={"Imagem Nossa Senhora"}/>
        
            <List titleOne={"Mãe de Deus"} titleTwo={"Virgem Imaculada"} titleThree={"Rainha do Céu"} titleFour={"Nova Eva"} titleFive={"Mãe da Igreja"}/>
<br/>
            <div className="btn-row">
            <CustomButton text={"História da Devoção Mariana"} route={"/NSA-Hist"}/>
            <CustomButton text={"Os Quatro Dogmas Marianos"} route={"/NSA-Dogmas"}/>
            <CustomButton text={"Maria na Liturgia e Crença Popular"} route={"/NSA-Pop"}/>
            <CustomButton text={"Documentos Oficiais Sobre Maria"} route={"/NSA-Docs"}/>
            </div>
            {/* Precisar consertar esta parte */}
            <br />
            <br />
            <br />
            <Footer/>
        </div>
    )
}